import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";

const Placeholder = ({ label }) => (
    <div
        data-testid="product-image-placeholder"
        className="w-full h-full flex flex-col items-center justify-center bg-[#FBF9F6] text-[#0A2342] p-8"
    >
        <div className="font-serif-display text-5xl md:text-6xl leading-none">
            C&amp;O
        </div>
        <div className="mt-4 w-10 h-px bg-[#9E5A35]" />
        <div className="mt-4 text-[10px] tracking-[0.35em] uppercase text-[#5C6A79] text-center">
            {label || "Design in progress"}
        </div>
    </div>
);

const ProductCard = ({ product }) => {
    const { addItem } = useCart();
    const isAvailable = product.status === "available";
    const hasImage = Boolean(product.image_url);

    const handleAdd = (e) => {
        e.preventDefault();
        addItem(product, 1);
        toast.success(`${product.name} added to cart`);
    };

    return (
        <Link
            to={`/product/${product.id}`}
            data-testid={`product-card-${product.id}`}
            className="group block bg-white border border-[#E5E0D8] rounded-sm overflow-hidden hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(10,35,66,0.08)] transition-all duration-500"
        >
            <div className="aspect-[4/5] bg-[#FBF9F6] overflow-hidden relative">
                {hasImage ? (
                    <img
                        src={product.image_url}
                        alt={product.name}
                        className="w-full h-full object-contain p-8 group-hover:scale-105 transition-transform duration-700 ease-out"
                    />
                ) : (
                    <Placeholder label="Coming Soon" />
                )}
                {!isAvailable && (
                    <span
                        data-testid={`product-badge-${product.id}`}
                        className="absolute top-4 left-4 bg-[#0A2342] text-[#FBF9F6] text-[10px] tracking-[0.22em] uppercase px-3 py-1.5"
                    >
                        Coming Soon
                    </span>
                )}
            </div>
            <div className="p-6 border-t border-[#E5E0D8]">
                <div className="flex items-baseline justify-between gap-3 mb-3">
                    <h3 className="font-serif-display text-xl text-[#0A2342] leading-tight">
                        {product.name}
                    </h3>
                    <span className="text-sm text-[#0A2342] font-medium whitespace-nowrap">
                        ${product.price.toFixed(2)}
                    </span>
                </div>
                {isAvailable ? (
                    <button
                        data-testid={`add-to-cart-${product.id}`}
                        onClick={handleAdd}
                        className="w-full text-[11px] tracking-[0.22em] uppercase text-[#0A2342] hover:text-[#9E5A35] pt-2 border-t border-transparent group-hover:border-[#9E5A35] transition-colors text-left"
                    >
                        Add to Cart →
                    </button>
                ) : (
                    <span
                        data-testid={`coming-soon-${product.id}`}
                        className="block w-full text-[11px] tracking-[0.22em] uppercase text-[#5C6A79] pt-2 border-t border-transparent"
                    >
                        Join Waitlist →
                    </span>
                )}
            </div>
        </Link>
    );
};

export default ProductCard;
